export const HowItWorks = () => {
  const steps = [
    {
      title: "Join",
      desc: "Enroll in course or internship",
    },
    {
      title: "Learn",
      desc: "Understand concepts deeply",
    },
    {
      title: "Build",
      desc: "Work on real projects",
    },
    {
      title: "Earn",
      desc: "Get stipend opportunities",
    },
    {
      title: "Grow",
      desc: "Get placed in jobs",
    },
  ];

  return (
    <section className="py-20 bg-gray-50 text-center">
      <h2 className="text-4xl font-bold mb-16">How It Works</h2>

      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">

        {steps.map((step, i) => (
          <div key={i} className="flex items-center w-full md:w-auto">

            {/* Step Card */}
            <div className="bg-white p-6 rounded-2xl shadow text-center w-full md:w-48 relative">

              {/* Number */}
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-blue-600 text-white w-10 h-10 flex items-center justify-center rounded-full text-sm font-bold shadow">
                {String(i + 1).padStart(2, "0")}
              </div>

              <h3 className="mt-4 font-semibold text-lg">{step.title}</h3>
              <p className="text-sm text-gray-500 mt-2">{step.desc}</p>
            </div>

            {/* Arrow (hide last) */}
            {i !== steps.length - 1 && (
              <div className="hidden md:flex items-center justify-center mx-4 text-blue-500 text-2xl">
                →
              </div>
            )}

          </div>
        ))}

      </div>
    </section>
  );
};